import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";
import Music from "./pages/Music";
import Landing from "./pages/Landing";
import AlbumPage from "./pages/AlbumPage";
import About from "./pages/About";
import Synthesizer from "./pages/Synthesizer";
import { ReleasesProvider } from "./contexts/MusicContext";

// Wrap the music + album pages in the ReleasesProvider context
// so that we only fetch the releases once
function MusicLayout() {
  return (
    <ReleasesProvider>
      <Outlet />
    </ReleasesProvider>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/synthesizer" element={<Synthesizer />} />
        <Route element={<MusicLayout />}>
          <Route path="/music" element={<Music />} />
          <Route path="/music/:album_name" element={<AlbumPage />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
